<div class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main" [ngClass]="{
        'fdx-c-modal__main--small': modalDialogType==='SMALL',
        'fdx-c-modal__main--medium':modalDialogType==='MEDIUM',
        'fdx-c-modal__main--large':(modalDialogType==='LARGE'),
        'fdx-c-modal__main--full-height': modalDialogType==='FULL_HEIGHT',        
        'fdx-c-modal__main--': modalDialogType==='DEFAULT'
      }">
        <div class="fdx-c-modal__body">
            <h3 class="fdx-c-modal__title" translate>{{modalDialogTitle}}</h3>
            <div class="fdx-c-modal__description" translate>
                {{modalDialogBodyContent}}
            </div>
            <div class="row" *ngIf="displayLeaveButton || displayStayButton">
                <div class="col-lg-12 col-sm-12">
                    <div class="fxg-button--float-right fdx-u-mt--4 fdx-u-mb--4">

                        <a (click)="raiseModalEvent('leave')"  *ngIf="displayLeaveButton"
                            class="fdx-c-button fdx-c-button--primary-outline fxg-margin-right">
                            {{"COMMON.CommonModaldialogButton_Leavepage" | translate: {Default: "LEAVE PAGE"} }}
                        </a>

                        <a (click)="raiseModalEvent('stay')" *ngIf="displayStayButton"
                            class="fdx-c-button fdx-c-button--primary fxg-margin-right">
                            {{"COMMON.CommonModaldialogButton_Stay" | translate: {Default: "STAY"} }}
                        </a>

                    </div>
                </div>
            </div>
        </div>
        <div class="fdx-c-modal__footer" *ngIf="dislayCloseButton">
            <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon"
                aria-label="close modal message: lorem ipsum" (click)="raiseModalEvent('close')">
                <div class="fdx-c-form-group__icon">
                    <svg class="fdx-c-icon" aria-hidden="true" focusable="false" role="presentation">
                        <use xlink:href="#cross"></use>
                    </svg>
                </div>
            </button>            
        </div>
    </div>
</div>